export default __webpack_public_path__ + "static/media/background-stalls.fb828eb8.svg";